<template>
	<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
		<div class="column-global">
			<div class="agency-review-writeble">
				<h3>나의 리뷰</h3>
				<div class="review-member-info">
					<div class="name">회원명 : {{nickname}}</div>
					<div class="post">번호 : {{user_info.post_id}}</div>
				<!-- 	<div class="count">누적 좋아요 : 0</div> -->
				</div>
				
				<el-tabs v-model="activeName" @tab-click="handleClick">
				    <el-tab-pane label="리뷰작성" name="first">
						<!-- fa_inventory_goods_status 表 id=29 配送完成 可以评论 ？  -->	
						<el-table
						  :data="list" empty-text="데이터가 없습니다"
						  stripe @row-click="clickDetails"
						  style="width: 100%; cursor: pointer;">
							<el-table-column
								type="index" v-if="!isMobile"
								label="순번"
								width="80">
							</el-table-column>
							<el-table-column
							  prop="goods_image" 
							  label="사진"
							  width="100">
							  <template slot-scope="scope">
									<el-image
									  style="width: 40px; height: 40px;border-radius:5px;" 
									  :src="scope.row.goods_image"
									  fit="cover">
									</el-image>
							  </template>
							</el-table-column>
							<el-table-column
							  prop="cate_name"
							  label="품목">
							</el-table-column>
							<el-table-column
							  prop="goods_name"
							  label="상품명">
							</el-table-column>
							<el-table-column
								prop="createtime"  v-if="!isMobile"
								label="작성일"
								width="180">
							</el-table-column>
							<el-table-column width="100" v-if="!isMobile">
								<template slot-scope="scope">
									<el-button size="mini" plain type="primary" >리뷰</el-button> <!-- @click="handleEdit(scope.$index, scope.row)" -->
								</template>
							</el-table-column>
						</el-table>
						
						<div class="page">
							<el-pagination
								layout="prev, pager, next" :page-size="20"
								:total="total"  @current-change="handleCurrentChange">
							</el-pagination>
						</div>

					</el-tab-pane>
				    <el-tab-pane label="작성한리뷰" name="second">
						<el-table
						  :data="list" empty-text="데이터가 없습니다"
						  stripe @row-click="onDetails"
						  style="width: 100%; cursor: pointer;">
							<el-table-column
								type="index" v-if="!isMobile"
								label="순번"
								width="80">
							</el-table-column>
							<el-table-column
							  prop="goods_image" 
							  label="사진"
							  width="100">
							  <template slot-scope="scope">
									<el-image
									  style="width: 40px; height: 40px;border-radius:5px;" 
									  :src="scope.row.goods_image"
									  fit="cover">
									</el-image>
							  </template>
							</el-table-column>
							<el-table-column
							  prop="cate_name"
							  label="품목">
							</el-table-column>
							<el-table-column
							  prop="goods_name"
							  label="상품명">
							</el-table-column>
							<el-table-column
								prop="createtime"  v-if="!isMobile"
								label="작성일"
								width="180">
							</el-table-column>
					
						</el-table>
						
						<div class="page">
							<el-pagination
								layout="prev, pager, next" :page-size="20"
								:total="total"  @current-change="handleCurrentChange">
							</el-pagination>
						</div>
					</el-tab-pane>
				
				</el-tabs>
				
				
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return {
				loading: true,
				user_info:{},
				total:0,
				page:1,
				activeName: 'first',
				list: [
					//{"id":1,"goods_image":"https://www.postteam.co.kr/data/files/2025/10/20/ba50fa7015585df66d785cedf4431a00.jpg","cate_name":"裤子","goods_name":"牛仔裤","createtime":"2025-11-12 13:30"}
				],
				
			};
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.nickname=localStorage.getItem('nickname')
			this.getUserInfo()
			this.getList()
		},
		methods: {
			async getUserInfo() {
				try {
					const res = await request.post('/User/getUserInfo', {});
					if (res.code == 1) {
						this.user_info = res.data;
						console.log("用户信息加载成功:", this.user_info);
					}
				} catch (error) {
					console.error("请求失败:", error);
				}
			},
			clickDetails(row, column, event){
				console.log(row,1)
				// console.log(column,2)
				// console.log(event,3)
				this.$router.push(`/reviewWrite/${row.id}`)
			},
			onDetails(row, column, event){
				this.$router.push(`/reviewDetails/${row.id}`)
			},
		    handleClick(tab, event) {
				console.log(tab, event);
				this.activeName = tab.name
				console.log(this.activeName)
				this.getList()
		    },
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			getList(){
				console.log(this.activeName,"切换")
				let active
				if(this.activeName=="first"){
					active = 1
				}else if(this.activeName=="second"){
					active = 2
				}
				this.loading = true
				request.post('/Comment/getUserCommentList',
					{
						page:this.page,
						active:active
					}
				).then(res => {
					this.loading = false
					console.log(res,"未评论列表")
					if(res.code ==1){
						// this.total = res.data.total
						this.list= res.data.data
					}		
				}).catch(() => {
					this.loading = false
				});
				
			}
		}
	}
</script>

<style scoped>
	.column-global{
		margin-top: 100px;
	}
	.agency-review-writeble h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0;
	    margin: 0 0 80px;
	}
	.review-member-info {
	    font-size: 24px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}
	
	::v-deep .el-tabs__item{
		font-size: 18px;
		font-weight: bold;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.column-global{
			margin:0 10px 40px;
		}
		.review-member-info {
			font-size: 18px;
		}
		::v-deep .el-tabs__item{
			font-size: 16px;
		}
	}
</style>